export const mainConfig = { apiUrl:"https://backapp.kipa.id/v3" }
